<template>
  <div
    class="w-full rounded-[16px] cursor-pointer overflow-hidden"
    style="aspect-ratio: 16 / 9"
    @click="gotoBF()"
  >
    <img :src="imageUrl" class="w-full h-full object-cover rounded-[16px]" />
  </div>
</template>
<script>
import { openUrl } from '@/utils/browser-helper';

export default {
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  methods: {
    async gotoBF() {
      if (this.url) {
        await openUrl(
          { url: this.url },
          {
            title: 'Building Fund Banner',
            source: 'my-giving-banner',
            page: 'MyGiving',
          },
        );
      }
    },
  },
};
</script>
<style scoped>
* {
  font-family: 'Inter';
}
</style>
